import React from "react";
import BudgetScreen from "../Containers/Budget/BudgetScreen";

export const BudgetRoute = (): React.JSX.Element => <BudgetScreen />

